/*
 *
 * MerchantPayByLinkDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 20-Nov-2024
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doHidePopup } from 'Store/actions/popup'
import * as PayByLinkActions from '../../modules/PayByLinkActions'
import MerchantPayByLinkDetail from './MerchantPayByLinkDetail'
import { doHideToast, doShowToast } from 'Store/actions/toast'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(PayByLinkActions, dispatch),
  ...bindActionCreators({ doShowToast, doHideToast }, dispatch),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.require_pbl, false),
  code: nullSafe(() => state.popup.popupInfo.code, ''),
  linkId: nullSafe(() => state.popup.popupInfo.linkId, ''),
  shouldSendLinkId: nullSafe(() => state.popup.popupInfo.shouldSendLinkId, false),
  orderDateTime: nullSafe(() => state.popup.popupInfo.orderDateTime, ''),
  expirationDate: nullSafe(() => state.popup.popupInfo.expirationDate, ''),
  clientName: nullSafe(() => state.popup.popupInfo.clientName, ''),
  paymentDate: nullSafe(() => state.popup.popupInfo.paymentDate, ''),
  paymentDescription: nullSafe(() => state.popup.popupInfo.paymentDescription, ''),
  amount: nullSafe(() => state.popup.popupInfo.amount, ''),
  facility: nullSafe(() => state.popup.popupInfo.facility, ''),
  buttonLabels: nullSafe(() => state.popup.popupInfo.buttonLabels, {}),
  typology: nullSafe(() => state.popup.popupInfo.typology, ''),
  status: nullSafe(() => state.popup.popupInfo.status, ''),
  shop: nullSafe(() => state.popup.popupInfo.shop, ''),
  terminalCode: nullSafe(() => state.popup.popupInfo.terminalCode, ''),
  linkInfo: nullSafe(() => state.popup.popupInfo.linkInfo, {}),
  link: nullSafe(() => state.popup.popupInfo.link, ''),
  storeOptions: nullSafe(() => state.popup.popupInfo.storeOptions, []),
  vatNumber: nullSafe(() => state.userProfiling.profiling.merchant.vatNumber, ''),
  fiscalCode: nullSafe(() => state.userProfiling.profiling.merchant.fiscalCode, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(MerchantPayByLinkDetail)
